import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Loader, Table } from 'semantic-ui-react';
import TableHeader from '@/components/table/TableHeader';
import Breadcrumb from '@/components/breadcrumbs/Breadcrumb';
import { firstErrorMessage } from '@/utils/errors';
import { states } from '@/constants/lifecycle';
import RequestAttachmentsTableColumns from './RequestAttachmentsTableColumns';
import RequestAttachmentsFilters from './RequestAttachmentsFilters';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';

const RequestAttachmentsTableHeader = ({
  attachments,
  category,
  code,
  columns,
}) => {
  const {
    readStatus, readErrors, segments, isRoot,
  } = Selectors.useRequestAttachmentsTableHeader({ category, code });
  const onNavigate = Events.useRequestAttachmentFolderNavigate(category, { code });

  return (
    <Table.Header fullWidth>
      <TableHeader
        className="aridhia-request-attachments-table-header"
        numberOfColumns={columns.length}
        error={firstErrorMessage(readErrors)}
      >
        <div>
          <FormattedMessage id="table.header.attachments.title" />
          {readStatus === states.PENDING && (<Loader active inline size="tiny" className="ml-10" />)}
        </div>
        <RequestAttachmentsFilters category={category} code={code} />
      </TableHeader>
      {!isRoot && (
        <TableHeader className="aridhia-request-attachments-navigation-table-header" numberOfColumns={columns.length}>
          <Breadcrumb segments={segments} onNavigate={onNavigate} />
        </TableHeader>
      )}
      <RequestAttachmentsTableColumns attachments={attachments} category={category} code={code} columns={columns} />
    </Table.Header>
  );
};

export default RequestAttachmentsTableHeader;
